module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-wood-rovere-vintage.f37b1288.jpg";